export function quantityInBundles(
  quantityInPieces: number,
  piecesPerBundle: number
): number {
  return piecesPerBundle > 0
    ? Math.ceil(quantityInPieces / piecesPerBundle)
    : quantityInPieces;
}
